import { ERROR, PENDING, SUCCESS } from '../../design-system/constants';
import { AllActions } from '../../shared/redux/types';

import * as actions from './actions';
import { MessageTemplateStatusState } from './types';

export const messageTemplateStatusReducer = (
    state: MessageTemplateStatusState = {},
    action: AllActions,
): MessageTemplateStatusState => {
    switch (action.type) {
        case actions.updateMessageTemplateRequestAction:
            return {
                ...state,
                patch: {
                    [action.messageTemplate.id]: PENDING,
                },
            };
        case actions.postNewMessageTemplateRequestAction:
            return {
                ...state,
                post: PENDING,
            };
        case actions.getAllMessageTemplatesRequestAction:
            return {
                ...state,
                get: PENDING,
            };
        case actions.getAllMessageTemplatesSuccessAction:
            return {
                ...state,
                get: SUCCESS,
            };
        case actions.updateMessageTemplateSuccessAction:
            return {
                ...state,
                patch: {
                    [action.id]: SUCCESS,
                },
            };
        case actions.updateMessageTemplateFailureAction:
            return {
                ...state,
                patch: {
                    [action.id]: ERROR,
                },
            };
        case actions.postNewMessageTemplateFailureAction:
            return {
                ...state,
                post: ERROR,
            };
        case actions.getAllMessageTemplatesFailureAction:
            return {
                ...state,
                get: ERROR,
            };
        case actions.postNewMessageTemplateSuccessAction:
            return {
                ...state,
                post: SUCCESS,
            };
        default:
            return state;
    }
};
